"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Lightbulb, Target, Users, Rocket, Trophy } from "lucide-react";
import { useEffect, useState } from "react";
export default function OurStoryAndMethod() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [lineProgress, setLineProgress] = useState(0);
  const steps = [{
    icon: Lightbulb,
    title: "Discovery",
    caption: "Deep market research and client needs analysis"
  }, {
    icon: Target,
    title: "Strategy",
    caption: "Custom real estate and SEO roadmap development"
  }, {
    icon: Users,
    title: "Collaboration",
    caption: "Transparent partnership throughout execution"
  }, {
    icon: Rocket,
    title: "Launch",
    caption: "Data-driven implementation and optimization"
  }, {
    icon: Trophy,
    title: "Results",
    caption: "Measurable outcomes and sustained growth"
  }];
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setLineProgress(100);
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  return <section ref={sectionRef} className="relative py-16 md:py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div className={`bg-muted rounded-lg p-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-6">
              Our Story & Method
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed mb-4">
              Nethill Limited was founded on a bold vision: to merge deep real estate expertise with cutting-edge digital marketing strategies. We recognized that success in Nigerian property markets requires more than local knowledge—it demands data intelligence, SEO mastery, and relentless innovation.
            </p>
            <p className="text-muted-foreground text-lg leading-relaxed">
              Our methodology is built on transparency, collaboration, and measurable results. Every project follows a proven five-step framework that transforms your real estate ambitions into tangible outcomes.
            </p>
          </div>

          {}
          <div className="relative">
            <div className="bg-dark-background rounded-lg p-8 md:p-10 min-h-[420px] relative">
              <div className="relative z-10">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-4">
                  {steps.map((step, i) => {
                  const Icon = step.icon;
                  const delay = i * 150;
                  return <div key={i} data-index={i} className={`group flex-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} hover:-translate-y-1 hover:scale-105`} style={{
                    transitionDelay: isVisible ? `${delay}ms` : "0ms"
                  }}>
                        <Card className="bg-background/10 backdrop-blur-sm border-primary/20 shadow-medium hover:shadow-strong hover:bg-background/15 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] h-full">
                          <CardContent className="p-5 flex flex-col items-center text-center gap-3">
                            <div className="bg-primary/20 rounded-full p-4 mb-2 group-hover:bg-primary/30 transition-colors duration-[var(--duration-medium)]">
                              <Icon className="w-7 h-7 text-primary group-hover:text-primary-hover transition-colors duration-[var(--duration-medium)]" />
                            </div>
                            <h3 className="text-foreground-dark font-display font-semibold text-lg">
                              {step.title}
                            </h3>
                            <p className="text-foreground-dark/70 text-sm leading-snug">
                              {step.caption}
                            </p>
                          </CardContent>
                        </Card>
                      </div>;
                })}
                </div>

                {}
                <div className="hidden md:block absolute top-[4.5rem] left-[10%] right-[10%] h-0.5 bg-primary/20">
                  <Progress value={lineProgress} className="h-0.5 bg-transparent" style={{
                  transition: "all 1200ms cubic-bezier(0.22,1,0.36,1)"
                }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}